<template>
  <div>
    <b-sidebar
      id="sidebar-ticket-view"
      sidebar-class="sidebar-xl"
      :visible="isTicketViewSidebarActive"
      bg-variant="light"
      shadow
      backdrop
      no-header
      right
      @change="(val) => clearCommentData(val)"
      @hidden="clearForm"
    >
      <template
        v-if="ticketLocal.id"
        #default="{ hide }"
      >
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1 text-white"
          :style="'background-color:'+ticketLocal.statut.couleur+' !important'"
        >
          <div style="position:absolute;left:-32px;top:48px;padding:6px 8px 6px 8px;box-shadow:-4px 5px 5px 0px rgb(0 0 0 / 25%) !important" class="bg-white text-dark">
            <feather-icon
                v-b-tooltip.hover.right="'Fermer la création/modification du ticket'"
                class="cursor-pointer"
                icon="XIcon"
                size="18"
                @click="hide"
            />
          </div>

          <h5
            class="mb-0 text-white"
          >
            {{ ticketLocal.titre }}
          </h5>
          <div>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>
        <b-tabs fill class="bg-white">

          <b-tab active class="bg-light">
            <template #title>
              <feather-icon
                icon="InfoIcon"
                size="16"
                class="mr-0 mr-sm-50"
              />
              <span class="d-none d-sm-inline">Détails</span>
            </template>
            <div class="p-2">
              <div class="row">
                <div class="col-6">
                  <b-card>
                    <h5 class="text-capitalize mb-75">
                      Service
                    </h5>
                    <p class="card-text text-primary font-weight-bold">
                      {{ ticketLocal.extra_field }}
                    </p>
                  </b-card>
                </div>
                <div class="col-6">
                  <b-card>
                    <h5 class="text-capitalize mb-75">
                      Chambre
                    </h5>
                    <p class="card-text text-primary font-weight-bold">
                      {{ ticketLocal.chambre }}
                    </p>
                  </b-card>
                </div>
              </div>
              <b-card>
                <h4 class="mb-2">
                  {{ ticketLocal.titre }}
                </h4>
                <div
                    v-if="ticketLocal.description"
                    class=""
                >
                  <p
                      v-html="ticketLocal.description"
                  />
                </div>
              </b-card>
              <div class="row">
                <div class="col-6">
                  <b-card bg-variant="transparent" class="shadow-none py-0">
                    <h5 class="text-capitalize mb-75">
                      Statut
                    </h5>
                    <p class="card-text text-primary font-weight-bold">
                      {{ ticketLocal.statut.titre }}
                    </p>
                  </b-card>
                </div>
                <div class="col-6">
                  <b-card bg-variant="transparent" class="shadow-none py-0">
                    <h5 class="text-capitalize mb-75">
                      Priorité
                    </h5>
                    <p class="card-text text-primary font-weight-bold">
                      {{ ticketLocal.priorite.titre }}
                    </p>
                  </b-card>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <b-card bg-variant="transparent" class="shadow-none py-0">
                    <h5 class="text-capitalize mb-75">
                      Créé par / Créé le
                    </h5>
                    <p class="card-text text-primary font-weight-bold">
                      {{ ticketLocal.created_by.name }} le  {{ formatDateTime(ticketLocal.created_at, { month: 'long', day: 'numeric'}) }} à {{ formatDateTime(ticketLocal.created_at, { hour: 'numeric', minute: 'numeric'}) }}
                    </p>
                  </b-card>
                </div>
                <div class="col-6">
                  <b-card bg-variant="transparent" class="shadow-none py-0">
                    <h5 class="text-capitalize mb-75">
                      Traité par
                    </h5>
                    <p
                        v-if="ticketLocal.assigne_user"
                        class="card-text text-primary font-weight-bold"
                    >
                      {{ ticketLocal.assigne_user.name }}
                    </p>
                    <p
                        class="card-text text-primary font-weight-bold"
                        v-if="!ticketLocal.assigne_user"
                    >
                      <small>non traité pour le moment</small>
                    </p>
                  </b-card>
                </div>
              </div>
            </div>
          </b-tab>

          <!-- Tab: Account -->
          <b-tab>
            <template #title>
              <feather-icon
                icon="MessageSquareIcon"
                size="16"
                class="mr-0 mr-sm-50"
              />
              <span class="d-none d-sm-inline">Observations ({{ ticketLocal.commentaires.length }})</span>
            </template>
            <section class="chat-app-window">
              <vue-perfect-scrollbar
                ref="refChatLogPSComment"
                :settings="perfectScrollbarSettings"
                class="user-chats scroll-area"
                style="height:85vh"
              >
                <div
                  v-if="ticketLocal.commentaires.length > 0"
                  class="chats"
                >
                  <div
                    v-for="msgGrp in ticketLocal.commentaires"
                    :key="msgGrp.id"
                    class="chat"
                    :class="'chat-left'"
                  >
                    <div class="chat-avatar">
                      <b-avatar
                          v-b-tooltip.hover
                          size="36"
                          class="avatar-border-2 box-shadow-1"
                          variant="primary"
                          :text="avatarText(msgGrp.created_by.name)"
                          :title="msgGrp.created_by.name"
                      />
                    </div>
                    <div class="chat-body">
                      <div
                        class="chat-content"
                      ><small>{{ msgGrp.created_by.name }}, le {{ formatDateTime(msgGrp.created_at, { month: 'long', day: 'numeric'}) }} à {{ formatDateTime(msgGrp.created_at, { hour: 'numeric', minute: 'numeric'}) }}</small>
                        <p class="font-weight-bold mt-1">
                          {{ msgGrp.contenu }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  pas de commentaire
                </div>
              </vue-perfect-scrollbar>
            </section>
          </b-tab>
        </b-tabs>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BAvatar, BButton, BFormInvalidFeedback, BTabs, BTab, VBTooltip, BCard,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, url } from '@validations'
import { avatarText, formatDateTime } from '@core/utils/filter'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ref, toRefs } from '@vue/composition-api'
import { quillEditor } from 'vue-quill-editor'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import useTicketHandler from './useTicketHandler'

export default {
  components: {
    // BSV
    BButton,
    BCard,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BAvatar,
    BFormInvalidFeedback,
    BTabs,
    BTab,

    VuePerfectScrollbar,
    // 3rd party packages
    vSelect,
    flatPickr,
    quillEditor,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  model: {
    prop: 'isTicketViewSidebarActive',
    event: 'update:is-ticket-view-sidebar-active',
  },
  props: {
    isTicketViewSidebarActive: {
      type: Boolean,
      required: true,
    },
    ticket: {
      type: Object,
      required: true,
    },
    clearTicketData: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
      url,
    }
  },
  setup(props, { emit }) {
    const {
      ticketLocal,
      resetTicketLocal,
      // UI
      assigneeOptions,
      onSubmit,
      statutOptions,
      resolveAvatarVariant,
    } = useTicketHandler(toRefs(props), emit)

    const {
      refFormObserver,
      getValidationState,
      resetForm,
      clearForm,
    } = formValidation(resetTicketLocal, props.clearTicketData)

    const userData = JSON.parse(localStorage.getItem('userData'))

    const editorOption = {
      modules: {
        toolbar: '#quill-toolbar',
      },
      placeholder: 'Détails du ticket',
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    const refChatLogPSComment = ref(null)
    const commentaires = ref(ticketLocal.value.commentaires)

    const clearCommentData = val => {
      emit('update:is-ticket-view-sidebar-active', val)
      if (val === false) {
        commentaires.value = []
      }
    }

    /* const scrollToBottomInChatLog = () => {
      const scrollEl = refChatLogPSComment.value.$el || refChatLogPSComment.value
      scrollEl.scrollTop = scrollEl.scrollHeight
    }
    nextTick(() => { scrollToBottomInChatLog() }) */

    return {
      // Add New
      ticketLocal,
      commentaires,
      onSubmit,
      assigneeOptions,
      statutOptions,
      clearCommentData,
      userData,
      perfectScrollbarSettings,
      refChatLogPSComment,
      /* scrollToBottomInChatLog, */
      formatDateTime,
      // Form Validation
      resetForm,
      clearForm,
      refFormObserver,
      getValidationState,

      // UI
      editorOption,
      resolveAvatarVariant,

      // Filter/Formatter
      avatarText,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/quill.scss';
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';
.assignee-selector {
  ::v-deep .vs__dropdown-toggle {
    padding-left: 0;
  }
}

#quil-content ::v-deep {
  > .ql-container {
    border-bottom: 0;
  }

  + #quill-toolbar {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
  }
}
.chat-container {
  background-image: url(data:image/svg+xml;base64,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);
  background-color: #f2f0f7;
  background-repeat: repeat;
  background-size: 210px
;
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
